<!-- Rows are permission-filtered server-side - refetch when the View All
     Company Objects toggle flips. An inline alert-editor detail pane is
     pending WAP-435 (auto-loading of data objects for inline forms); when it
     lands, follow the company-categories sideRegion recipe. -->
<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="alerts-grid"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
  [refreshOnCompanyObjectsToggle]="true"
></app-data-grid>
